module.exports = __webpack_public_path__ + "img/PL09367.7639b444.png";